import { Component} from '@angular/core';
import { UntilDestroy } from 'ngx-unificator/decorator';
import { AccessRestrictedComponent } from '../access-restricted/access-restricted.component';
import { HeaderSimpleComponent } from '../../layout/header-simple/header-simple.component';

@UntilDestroy()
@Component({
  selector: 'app-full-account-lock',
  templateUrl: './full-account-lock.component.html',
  styleUrls: ['./full-account-lock.component.scss'],
  imports: [AccessRestrictedComponent, HeaderSimpleComponent],
})
export class FullAccountLockComponent {

}
